module.exports = __webpack_public_path__ + "img/singleusericon.b996495b.svg";